import styled from "styled-components";
import { Box, Container, responsive } from "styled-minimal";
import { UserState } from "types";
import { coaches } from "config";

export const StyledBox = styled(Box)<Pick<UserState, 'coach'>>`
  background-size: cover;
  background-position: center;
  background-image: '${process.env.PUBLIC_URL}/media/images/venn-graph.png';
  // background: rgb(79, 169, 151);
  background: rgb(55, 65, 81);
  overflow: hidden;
  height: calc(100vh);
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-direction: column;
  position: relative;
`;
export const LeftSide = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const RightSide = styled.div`
  position: absolute;
  right: 0px;
  top: 0;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

export const ChatWrapper = styled.div`
  position: relative;
  height: 100%;
`;

export const ToggleTab = styled.button<{ open: boolean; hint?: boolean }>`
  position: absolute;
  right: -28px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 64px;
  background: rgb(238, 238, 238);
  border: none;
  border-radius: 0 10px 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 11px;
  z-index: 10;
  padding: 0;
  ${({ hint }) => hint && `
    animation: tab-pulse 2s ease-in-out infinite, tab-outline 1s step-end infinite;
  `}

  @keyframes tab-pulse {
    0%, 100% { background: rgb(238, 238, 238); }
    50% { background: #d4a8d8; }
  }

  @keyframes tab-outline {
    0%, 100% { outline: 3px solid #E8A83A; outline-offset: 2px; }
    50%       { outline: 3px solid transparent; outline-offset: 2px; }
  }

  &:hover {
    background: #d0d0d0;
    animation: none;
    outline: none;
  }
`;

export const HintCallout = styled.div<{ visible: boolean }>`
  position: absolute;
  right: 44px;
  top: 50%;
  transform: translateY(-50%);
  width: 220px;
  background: #600b68;
  color: white;
  border-radius: 12px;
  padding: 14px 16px 14px 14px;
  font-size: 1.3rem;
  line-height: 1.5;
  z-index: 20;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  pointer-events: ${({ visible }) => (visible ? 'all' : 'none')};
  transition: opacity 0.3s ease;

  /* right-pointing arrow toward the toggle tab */
  &::after {
    content: '';
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translateY(-50%);
    border: 6px solid transparent;
    border-left-color: #600b68;
  }
`;

export const HintDismiss = styled.button`
  position: absolute;
  top: 6px;
  right: 8px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.4rem;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  &:hover { color: white; }
`;

export const ToolsDrawer = styled.div<{ open: boolean }>`
  position: absolute;
  left: calc(100% + 28px);
  top: 0;
  bottom: 0;
  width: 200px;
  background: rgb(238, 238, 238);
  border-radius: 20px;
  padding: 20px 0 0;
  z-index: 9;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  opacity: ${({ open }) => (open ? 1 : 0)};
  pointer-events: ${({ open }) => (open ? 'all' : 'none')};
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(-10px)')};
  transition: opacity 0.2s ease, transform 0.2s ease;
`;

export const DrawerDivider = styled.hr`
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  margin: 4px 16px;
`;

export const DrawerFooter = styled.div`
  margin-top: auto;
  padding: 10px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DrawerLink = styled.a`
  font-size: 1.25rem;
  color: #555;
  text-decoration: none;
  padding: 6px 0;
  cursor: pointer;
  background: none;
  border: none;
  text-align: left;

  &:hover { color: #600b68; text-decoration: underline; }
`;

export const StyledContainer = styled(Container)<Pick<UserState, 'coach'>>`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  background-color: white;
  max-width: 870px;
  padding: 0 20px 16px;
  width: 870px;
  border-radius: 20px;

  & > ul {
    & > li {
      list-style-type: none;
    }
  }

  & > ul {
    width: 100%;
    flex: 1;
    padding-right: 30px;
    padding-top: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    padding-left: 10px;

    ::-webkit-scrollbar {
      width: 10px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgb(151, 155, 166);
    }
    ::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: rgb(238, 238, 238);
    }
  }

  & > ul > li {
    margin-bottom: 20px;
    padding: 0 20px;
    position: relative;
    border-radius: 10px;
    font: 0.9em / 1.6 'Helvetica';
    max-width: 300px;
    /* background: ${({ coach }) =>
      `linear-gradient(to right, ${coaches[coach].primary}, ${coaches[coach].default})`}; */

    & > button {
      color: white;
      position: absolute;
      bottom: 10px;
      right: 10px;
    }

    ${responsive({
      md: { font: "1em / 1.8 'Helvetica'" },
    })};
    // color: rgba(255, 255, 255, 0.9);
    color: white;
    background: #374151;
    // text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.75);
    clear: both;
  }
  & > ul > li:nth-child(odd) {
    float: left;
    /* ${responsive({
      md: { marginLeft: '80px' },
    })}; */
  }
  & > ul > li:nth-child(even) {
    float: right;
    margin-right: 0px;
    /* ${responsive({
      md: { marginRight: '80px' },
    })}; */
    // background: linear-gradient(to right, #4c5094, #6d71ba);
    background: #600b68;
    color: white;
  }
  & > ul > li:before,
  & > ul > li:after {
    position: absolute;
    content: '';
  }
  & > ul > li:before {
    width: 60px;
    height: 60px;
    top: -6px;
    border-radius: 50%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: none;
    ${responsive({
      md: { display: 'block' },
    })};
  }
`;

export const Input = styled.textarea`
  border: none;
  background-image: none;
  background-color: white;
  padding: 0.5rem 1rem;
  border-radius: 1.125rem;
  flex-grow: 1;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.1), 0rem 1rem 1rem -1rem rgba(0, 0, 0, 0.2);
  letter-spacing: 0.025em;
  font: 0.9em 'Helvetica';
  line-height: 1.6;
  resize: none;
  overflow-y: hidden;
  min-height: 42px;
  max-height: 200px;

  ${responsive({
    md: { fontSize: '1em' },
  })};
  outline: 2px solid grey;
`;

export const Button = styled.button`
  width: 42px;
  height: 42px;
  background-color: white;
  border-radius: 50%;
  border: 3px solid transparent;
  color: rgb(79, 169, 151);

  &:hover {
    background-color: lightgrey;
  }

  &:active {
    color: white;
    background-color: #555;
  }
`;

export const MicButton = styled.button<{ recording?: boolean }>`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 3px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ recording }) => (recording ? '#e53e3e' : 'white')};
  color: ${({ recording }) => (recording ? 'white' : 'rgb(79, 169, 151)')};
  transition: background-color 0.2s, color 0.2s;

  ${({ recording }) =>
    recording &&
    `
    animation: mic-pulse 1.2s ease-in-out infinite;
  `}

  @keyframes mic-pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.12); }
  }

  &:hover {
    background-color: ${({ recording }) => (recording ? '#c53030' : 'lightgrey')};
  }

  &:active {
    color: white;
    background-color: #555;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const InputBox = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
`;

